import React from 'react';

import Card from "@mui/material/Card";
import Typography from '@mui/material/Typography';

import PropertyContainerCard from "./PropertyContainerCard";

import IParamScript from '../../database/interfaces/paramScript/IParamScript';
import { useTheme } from '@mui/material/styles';

interface IPropertyCardListProps {
    titles: Record<string, IParamScript[]>;
}

const PropertyCardList: React.FC<IPropertyCardListProps> = ({ titles }) => {
    return Object.keys(titles).map(title => {
        const paramScripts = titles[title];
        // Individual headerless property cards if no title is set
        if (title === "") {
            return paramScripts.map(script => (
                <PropertyContainerCard
                    key={script.id}
                    title=""
                    properties={[script]}
                    />
            ));
        }
        return <PropertyContainerCard
            key={title}
            title={title}
            properties={paramScripts}
        />;
    });
}
/**
 * Base class for the cabinet panel container cards. These group property cards.
 */
interface IPanelContainerCardProps {
    panel: string;
    titles: Record<string, IParamScript[]>;
}

const PanelContainerCard: React.FC<IPanelContainerCardProps> = ({ panel, titles }) => {
    const theme = useTheme();

    if (Object.keys(titles).length === 0) {
        return null;
    }

    return (panel !== ""
        ?
        <Card sx={{ margin: 1, padding: 1, backgroundColor: theme.palette.background.paper,  }}>
            <Typography variant="h6" component="div">
                {panel}
            </Typography>
            <PropertyCardList titles={titles} />
        </Card>
        : // Not in a panel
        <PropertyCardList titles={titles} />
    );
}

export default PanelContainerCard;
